import { render, staticRenderFns } from "./OdemeTaahhuduTaslak.vue?vue&type=template&id=5ca2c9c5&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./OdemeTaahhuduTaslak.vue?vue&type=script&lang=ts"
export * from "./OdemeTaahhuduTaslak.vue?vue&type=script&lang=ts"
import style0 from "./OdemeTaahhuduTaslak.vue?vue&type=style&index=0&id=5ca2c9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca2c9c5",
  null
  
)

export default component.exports